<div class="range-filter-section">
  <div
    *ngIf="
      loading &&
      ((activePanel === panel.key && refreshCurrentPanel) ||
        activePanel !== panel.key)
    "
  >
    <va-custom-skeleton></va-custom-skeleton>
  </div>
  <nz-range-picker
    *ngIf="!loading || (activePanel == panel.key && !refreshCurrentPanel)"
    nzDropdownClassName="pharma-range-picker"
    [(ngModel)]="dateRange"
    (ngModelChange)="onRangeChange($event)"
    ></nz-range-picker>
</div>